import { FC, useEffect} from 'react';

import {Grid, Typography} from "@mui/material";

const Help: FC = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <Grid container>
            <Grid item xs={12}>
                <Typography variant="body1">
                    <br/>
                    <br/>
                    <b>Please contact Code Services with any questions or if you encounter any difficulties completing this form, via phone or email at:</b><br/>
                    <b>Phone:</b> 866.609.2447<br/>
                    <b>Email:</b> cbcodeservices@collegeboard.org
                </Typography>
            </Grid>
        </Grid> );
};

export default Help;
